import * as yup from "yup";

import {GENDER_VALUES} from "shared/constants/gender";
import {SMOKING_VALUES} from "shared/constants/smoking";
import {US_STATE_VALUES} from "shared/constants/usState";
import {UI_PAYMENT_VALUES} from "shared/constants/payment";
import {RATE_CLASSES_VALUES} from "shared/constants/rateClasses";
import {TERM_VALUES} from "shared/constants/terms";
import {TABLE_RATING_VALUES} from "shared/constants/tableRating";

const quoteInputSchema = yup.object()
    .shape({
        dob: yup.date().required(),
        gender: yup.string().oneOf(GENDER_VALUES).required(),
        smoking: yup.string().oneOf(SMOKING_VALUES).required(),
        state: yup.string().oneOf(US_STATE_VALUES).required(),
        payment: yup.string().oneOf(UI_PAYMENT_VALUES).required(),
        amount: yup.number().required(),
        rateClasses: yup.array(yup.string().oneOf(RATE_CLASSES_VALUES)).required(),
        term: yup.string().oneOf(TERM_VALUES).required(),
        tableRating: yup.string().oneOf(TABLE_RATING_VALUES),
    });

export default quoteInputSchema;
